import { useState } from 'react';
import { FileUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DceUploadDialog } from './DceUploadDialog';

interface DceUploadButtonProps {
  opportunityId: number;
  variant?: 'default' | 'outline' | 'ghost';
}

export function DceUploadButton({
  opportunityId,
  variant = 'outline',
}: DceUploadButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant={variant} onClick={() => setOpen(true)}>
        <FileUp className="h-4 w-4 mr-2" />
        Importer DCE
      </Button>
      <DceUploadDialog
        opportunityId={opportunityId}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
}
